<template>
	<div class="sports-run">
		<p class="flex end">
			<span @click="visableRule=true" class="btn-rule flex">规则</span>
		</p>
		<span class="distance flex center">{{$runBridge.km}}</span>

		<div class="cards flex start">
			<div class="card">
				<p>跑步时长</p>
				<p>{{$runBridge.duration}}</p>
			</div>
			<div class="card">
				<p>平均配速</p>
				<p>{{$runBridge.paceAvg||0}}</p>
			</div>
			<div class="card">
				<p>消耗卡路里</p>
				<p>{{$runBridge.calorie}}</p>
			</div>
			<div class="card">
				<p>步频</p>
				<p>{{$runBridge.cadence}}</p>
			</div>
		</div>

		<div class="btns flex around">
			<!-- <button @click="test">test</button> -->
			<img v-if="$runBridge.status===1" v-throttle @click="pause" src="@img/icon/btn_suspend.png" alt />
			<img v-if="$runBridge.status===2" v-throttle @click="goOn" src="@img/icon/btn_play.png" alt />
			<div v-if="[2,3].includes($runBridge.status)" v-longpress @click="toExit" class="img"></div>
		</div>
		<p class="tips flex center">
			<span class="flex">跑步锻炼期间请勿离开打卡区域</span>
		</p>

		

		<!-- <div v-if="$runBridge.status==-1" class="prepare flex center">
			<span class="flex">倒计时</span>
			<span class="time">{{prepareTime}}s</span>
		</div> -->

		<!-- @init="loding = 1" @end="submit" @reach="openReach" -->
		<!-- run.html -->
		<iframe src="run/index.html" ref="run" class="run" frameborder="0" :style="{ display: $runBridge.display ? 'block' : 'none' }"></iframe>
<!--    <iframe src="https://test.9shadow.com/h5-unrealRunTest-run/index.html" ref="run" class="run" frameborder="0" :style="{ display: $runBridge.display ? 'block' : 'none' }"></iframe>-->
<!--    <iframe src="https://test.9shadow.com/h5-unrealRunTest-run/index.html" ref="run" class="run" frameborder="0" :style="{ display: $runBridge.display ? 'block' : 'none' }"></iframe>-->

		<popup v-model="visableRule" :msg="ruleInfo||'暂未配置'" btns="1" okText="知道了" type="dialogue" title="跑步打卡规则" @confirm="visableRule=false" @close="visableRule=false"></popup>
		<popup v-model="visableExit" msg="当前运动时间过短，是否确认退出？" okText="确定" title="提示" type="dialogue" @confirm="submitResult" @close="visableExit=false"></popup>
		<popup v-model="visableIshere" msg="请回到打卡区域，否则成绩无效" btns="1" okText="确定" title="提示" type="dialogue" @confirm="visableIshere=false"></popup>
	</div>
</template>

<script>
export default {
	data() {
		return {
			visableRule: false,
			visableExit: false,
			visableIshere: false,
			ruleInfo: undefined,

			runConfig: {
				km: 0,
				duration: "",
				motionTime: "",
				paceAvg: "",
				calorie: 0,
			},

			// runConfig: {
			// 	km: 11.1,
			// 	duration: "00:30:00",
			// 	motionTime: "2024-01-08 10:51:00",
			// 	paceAvg: "5'32''",
			// 	calorie: 500,
			// },

			prepareTimer: undefined,
			prepareTime: 3,

			pauseTime: 0, //暂停时长统计
			pauseTimer: undefined,

			// 最短时长 - 5分钟
			minDurationTime: 5 * 60,

			// 最大暂停时长 - 30分钟
			maxPauseTime: 30 * 60,
		};
	},

	computed: {
		durationToSeconds() {
			let seconds = 0;
			if (this.$runBridge.duration) {
				let tArr = this.$runBridge.duration?.split(":") || [0, 0, 0];
				seconds = Number(tArr[0]) * 60 * 60 + Number(tArr[1]) * 60 + Number(tArr[2]) || 0;
			}
			return seconds;
		},
	},

	watch: {
		$runBridge: {
			handler(val) {
				console.log("parent.watch.runBridgeChange", this.$runBridge);
			},
			deep: true,
			immediate: true,
		},
		"$runBridge.isHere": {
			handler(val) {
				if (!isHere) this.visableIshere = true;
			},
		},
	},

	mounted() {
		// 结束跑步后 需要打卡
		this.noSleep();
		this.getRules();
		this.studentWeight();
		// this.prepareTimer = setInterval(() => {
		// 	this.prepareTime--;
		// 	if (this.prepareTime < 1) this.startPlay();
		// }, 1000);

		this.startPlay();
	},

	methods: {
		toExit() {
			if (this.durationToSeconds > this.minDurationTime) {
				this.submitResult();
			} else this.visableExit = true;
		},
		//屏幕常亮
		noSleep() {
			let noSleep = new this.$NoSleep();
			document.addEventListener(
				"click",
				function enableNoSleep() {
					noSleep.enable();
					document.removeEventListener("click", enableNoSleep, false);
				},
				false
			);
		},

		startPlay() {
			this.$runBridge.status = 1;
			clearInterval(this.prepareTimer);
			this.runConfig.motionTime = new Date()
				.toLocaleString()
				.replace(/\//g, "-");
			// 通知$runBridge start
			// this.$refs.run.contentWindow.gyroscope();
		},

		pause() {
			this.$runBridge.status = 2;
			this.$refs.run.contentWindow.pauseGyroscope();
			this.pauseTimer = setInterval(() => {
				this.pauseTime++;
				// 累计暂停30分钟 自动结束跑步
				if (this.pauseTime > this.maxPauseTime) {
					clearInterval(this.pauseTimer);
					this.submitResult();
				}
			}, 1000);
		},

		goOn() {
			this.$runBridge.status = 1;
			if (this.pauseTimer) clearInterval(this.pauseTimer);
			// 通知$runBridge continue
			// this.$refs.run.contentWindow.gyroscope();
			this.$refs.run.contentWindow.continueGyroscope();
		},

		async getRules() {
			try {
				let { success, message, result } = await this.$http.get(
					"h5/homePage/runningConfig"
				);
				if (!success) throw new Error(message);
				this.ruleInfo = result;
			} catch (error) {
				console.log("getRules", error);
			}
		},

		async submitResult() {
			this.$refs.run.contentWindow.stopGyroscope();
			let { km, paceAvg, calorie, cadence, duration } = this.$runBridge;
			this.runConfig.km = km;
			this.runConfig.duration = duration;
			this.runConfig.paceAvg = paceAvg;
			this.runConfig.calorie = calorie;
			console.log("parent.submit.runConfig", this.runConfig);
			try {
				let { success, message } = await this.$http.post(
					"h5/homePage/addRunning",
					this.runConfig
				);
				if (!success) throw new Error(message);
				this.$message(message);
				this.$router.go(-1);
			} catch (error) {
				this.$message(error?.message);
				console.log("submitResult", error?.message);
			}
		},
		async studentWeight() {
		    try {
				let {message,success,result} = await this.$http.get("/h5/my/getStudentWeight");
				if (!success) throw new Error(message);
				console.log('getStudentWeight',result);
				// window.localStorage.setItem("weight", result);
				window.weight = result;

				console.log('weight',window.weight);
				this.$message(message);
			} catch (error) {
				// console.log('体重出错');
				this.$message(error?.message);
			}
		}
	},

	beforeDestroy() {
		// clearInterval(this.prepareTimer);
		// clearInterval(this.pauseTimer);


		this.$runBridge.status = -1;
		this.$runBridge.isHere = false;
		this.$runBridge.km = 0;
		this.$runBridge.paceAvg = "";
		this.$runBridge.calorie = 0;
		this.$runBridge.cadence = 0;
		this.$runBridge.duration = 0;
		this.$runBridge.display = true;
	},
};
</script>

<style scoped lang="less">
.sports-run {
	padding: 17 / @rem;

	.btn-rule {
		font-size: 15 / @rem;
		color: rgba(255, 162, 22, 1);
		&::before {
			content: "";
			display: flex;
			width: 13 / @rem;
			height: 14 / @rem;
			margin-right: 5 / @rem;
			background-image: url(~@img/icon/ui_rule.png);
			background-repeat: no-repeat;
			background-size: contain;
		}
	}

	.distance {
		height: 144 / @rem;
		font-size: 61 / @rem;
		font-weight: bold;
		&::after {
			content: "（公里）";
			font-size: 19 / @rem;
			font-weight: 400;
		}
	}

	.cards {
		flex-wrap: wrap;
		.card {
			width: 165 / @rem;
			height: 85 / @rem;
			margin-right: 11 / @rem;
			margin-bottom: 11 / @rem;
			padding: 11 / @rem 15 / @rem;
			background: #fff6e9;
			border-radius: 12 / @rem;
			p:first-child {
				padding-bottom: 13 / @rem;
				font-size: 14 / @rem;
				color: rgba(31, 30, 29, 0.3);
			}
			p:last-child {
				font-size: 21 / @rem;
				font-weight: bold;
				color: rgba(255, 162, 22, 1);
			}
			&:nth-child(2n) {
				margin-right: 0;
			}
		}
	}

	.btns {
		padding: 45 / @rem 0 33 / @rem;
		img,
		.img {
			width: 92 / @rem;
			height: 92 / @rem;
			border-radius: 50%;
		}
		.img {
			background-image: url(~@img/icon/btn_close.png);
			background-repeat: no-repeat;
			background-size: contain;
		}
	}

	.tips {
		span {
			&::before {
				content: "";
				display: flex;
				width: 18 / @rem;
				height: 18 / @rem;
				margin-right: 3 / @rem;
				background-image: url(~@img/icon/ui_location.png);
				background-repeat: no-repeat;
				background-size: contain;
				background-position: center;
			}
		}
	}
}

.prepare {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background-color: rgb(0, 0, 0);
	span {
		font-size: 22 / @rem;
		color: rgba(255, 162, 22, 1);
		align-items: flex-end;
	}
	span.time {
		font-size: 51 / @rem;
		padding: 0 11 / @rem;
	}
}
</style>



<style scoped>

iframe.run {
	width: 100%;
	height: 100%;
	
	position: fixed;
	left: 0;
	top: 0;
	z-index: 10000;
}
</style>